import React from "react";
import "./styles.scss";

const Card = (props) => {
  const { sub_content } = props;
  return (
    <div className="card-view-container">
      <div className="sub-container">
        {sub_content?.map((item, index) => {
          return (
            <div key={index} className="section">
              <h3>{item?.sub_title}</h3>
              <p
                className="content"
                dangerouslySetInnerHTML={{ __html: item?.sub_description }}
              />
              <div className="image-container">
                <img src={item?.sub_image} alt="safety banner" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Card;
